import {Component, OnInit, Input} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {environment} from '../../../environments/environment';
import * as angular from 'angular';
import {resolve} from 'url';
import {FormBuilder} from '@angular/forms';
import {PayGateService} from 'app/services/paygate.service';
import {CarrierService} from 'app/services/carrier.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {accounting} from 'accounting';
import {PopupService} from 'app/services/shared/popup.service';
import {ToastrService} from 'ngx-toastr';
import {retry} from 'rxjs/operator/retry';
import {ApplicationService} from 'app/services/application.service';
import {error} from 'console';
import {AnnualComplianceService} from 'app/annual-compliance/service/annual-compliance.service';
import {WorkflowService} from 'app/services/workflow.service';
import {PermitService} from '../../services/permit.service';
import {CorspdcService} from '../../services/corspdc.service';
import {ProcessActivityDTO} from '../../models/processactivitydto';

declare var $: any;

@Component({
    selector: 'app-account-deposit',
    templateUrl: './paymentComplete.component.html',
    styleUrls: ['./paymentComplete.component.css']

})
export class PaymentCompleteComponent implements OnInit {
    @Input() dataCntrl: any;
    @Input() isApproval: boolean = false;

    isLoading = false;
    message = 'Loading. Please wait...';
    instructMsg = '';
    departuresList: any = [];
    departuresListRemove: any = [];
    editFlag: boolean = false;
    pageload: boolean = false;
    showBlock: boolean = false;

    payReqId: string = '';
    checkSum: string = '';
    carrierid: any;
    Carrier: any;
    amountDisplay: any;
    amount: any;
    paymentRef: string = '';
    status: number;
    statusDesc: string = '';

    permitStatus1;
    permitStatus2;
    permitStatus4;
    permitStatus6;
    permitStatus7;
    permitStatus10;
    permitStatus13;
    permitStatus14;
    newStatus;
    selectedapp: any;
    renewFlag: any;
    userDetails: any = null;

    activityDTO = new ProcessActivityDTO();

    constructor(private formBuilder: FormBuilder,
                private payGateService: PayGateService,
                private carrierService: CarrierService,
                private activeRoute: ActivatedRoute,
                private msgService: PopupService,
                private applicationService: ApplicationService,
                private msg: ToastrService,
                private crspdService: CorspdcService,
                private permitService: PermitService,
                private _annualCompliance: AnnualComplianceService,
                private workflowService: WorkflowService,
                private router: Router) {
    }

    ngOnInit() {

        this.userDetails = environment.authWebApi.userData.User;
        this.activeRoute.params.subscribe((params: Params) => {
            this.carrierid = params['id'];
            this.status = Number(params['status']);
            this.paymentRef = params['refNum'];
            switch (this.status) {
                case 0 :
                    this.statusDesc = 'Not Done';
                    break;
                case 1 :

                    //Handle Permit Payments
                    this.statusDesc = 'Approved';
                    let application_Id = localStorage.getItem('ApplicationIDOnSubmit');
                    this.renewFlag = localStorage.getItem('ApplicationRenewalFlagOnSubmit');
                    if (application_Id) {

                        this.applicationService.getById(application_Id).subscribe((app: any) => {
                                if (app) {
                                    this.selectedapp = app;
                                    this.permitService.GenerateApplicationPermitInvoices(app.id).subscribe((result: any) => {
                                        if (result.Message === 'Approved') {
                                            this.determineStatus(app);
                                        } else {
                                            console.error('Not successful ', result);
                                        }
                                    });

                                    app.status_id = 11;
                                    this.applicationService.putApplication(app).subscribe(result => {

                                    });
                                    localStorage.removeItem('ApplicationIDOnSubmit');
                                }
                            }, error => {
                                console.log(error);
                            }
                        )
                    }
                    //Handle Compliance Payments
                    let ids = localStorage.getItem('ComplianceIdsSubmitted');
                    if (ids) {
                        const stringArray: string[] = ids.split('_'); // Split the string into an array
                        const numberArray: number[] = stringArray.map(str => parseInt(str, 10));
                        console.log('ComplianceIdsSubmitted', ids);
                        for (const id of numberArray) {
                            this._annualCompliance.UpdateComplianceStatuses(id, 'AnnComplianceStatus3').subscribe((result: any) => {
                                this.initiateWorkflow();
                            });
                        }
                    }

                    break;
                case 2 :
                    this.statusDesc = 'Declined';
                    break;
                case 3 :
                    this.statusDesc = 'Cancelled';
                    break;
                case 4 :
                    this.statusDesc = 'User Cancelled';
                    break;
                case 5 :
                    this.statusDesc = 'Received by PayGate';
                    break;
                case 7 :
                    this.statusDesc = 'Settlement Voided';
                    break;
            }

            this.LoadCarrierAccountDetails();
        });
    }


    formatCurrency(value) {
        return accounting.formatMoney(value, 'R', 2, ' ', '.');
    }

    LoadCarrierAccountDetails() {
        this.carrierService.getById(this.carrierid).subscribe(carrier => {
            this.Carrier = carrier;
            console.log(carrier);
        });
    }


    backToTab() {
        this.router.navigateByUrl('carrier/accounts/VCA');
    }

    initiateWorkflow() {

        let ids = localStorage.getItem('ComplianceIdsSubmitted');
        const stringArray: string[] = ids.split('_'); // Split the string into an array
        const numberArray: number[] = stringArray.map(str => parseInt(str, 10));

        for (const id of numberArray) {
            this.workflowService.initiateComplianceWorkflow(id)
                .subscribe(
                    async (result: any) => {
                        console.log(result);
                        localStorage.removeItem('ComplianceIdsSubmitted');
                    },
                    (error) => {
                        this.isLoading = false;
                    }
                );

        }
    }

    determineStatus(app) {

        if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {

            this.permitStatus1 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus1').Value;
            this.permitStatus2 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus2').Value;
            this.permitStatus4 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus4').Value;
            this.permitStatus6 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus6').Value;
            this.permitStatus7 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus7').Value;
            this.permitStatus10 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus10').Value;
            this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
            this.permitStatus14 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus14').Value;
            this.newStatus = this.permitStatus2;

            if ((app.permittype.freight_passenger_ind == 2 && app.permittype.temp_long_ind == 2 && app.permittype.charge_when_ind == 1)) {
                if (app.permittype.status_id == this.permitStatus13 || app.status_id == this.permitStatus14) {
                    this.newStatus = this.permitStatus2;
                } else {
                    this.newStatus = this.permitStatus7;
                }
            } else {
                this.newStatus = this.permitStatus2;
            }

            this.saveConfirmation(this.newStatus, app);

        } else {
            console.error('AuthWeb Environment', 'Values could not be obtained');
        }


    }

    saveConfirmation(permitStatus, app) {
        if (this.renewFlag) {
            this.saveApplication(app);
        } else {
            this.updateConfm(permitStatus);
        }

    }


    saveApplication(app) {
        let object: any = Object();
        object['date_modified'] = app.date_modified;
        object['user_modified'] = app.user_modified;
        object['reference_num'] = app.reference_num;
        object['permit_type_id'] = app.permit_type_id;
        object['person_id'] = app.person_id;
        object['carrier_id'] = app.carrier_id;
        object['date_created'] = app.date_created;
        object['user_created'] = app.user_created;
        this.applicationService.postApplication(object)
            .subscribe(result => {
                this.savePermit(result, app);
            });
    }

    updatePermitRenew() {
        if (this.dataCntrl.permits.renewal_num == null) {
            this.dataCntrl.permits.renewal_num = 1;
        } else {
            this.dataCntrl.permits.renewal_num = parseInt(this.dataCntrl.permits.renewal_num) + 1;
        }
        this.permitService.upadatePermit(this.dataCntrl.permit)
            .subscribe((result: any) => {
                result.renewal_num = this.dataCntrl.permits.renewal_num;
                this.dataCntrl.permit = result;
            });
    }

    savePermit(data, app) {
        this.updatePermitRenew();
        this.selectedapp.permits.forEach(permit => {
            let permitObject: any = JSON.parse(JSON.stringify(permit));
            permitObject.permit_type_id = data.permit_type_id;
            permitObject.application_id = data.id;
            permitObject.date_modified = permit.date_created = new Date();
            permitObject.user_modified = permit.user_created = environment.authWebApi.userData.User.FirstName;
            permitObject.permit_fee = app.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee;
            permitObject.application_fee = app.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee;
            permitObject.status_id = 11;
            permitObject.date_11 = null;
            permitObject.date_valid_from = null;
            permitObject.date_valid_to = null;
            permitObject.number_passengers = app.vehicle[0].number_passengers;
            this.permitService.postPermit(permitObject)
                .subscribe(result => {
                   // this.saveVehicles(result, data, app);
                });
        });
    }

    updateConfm(permitStatus) {
        this.pageload = true;
        const config: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == 'SubmitEmail2');

        let payload: any = Object();
        payload['carrier_id'] = this.dataCntrl.carrierID;
        payload['application_id'] = this.dataCntrl.application.id;
        //payload['permit_id'] = this.dataCntrl.permits.id;
        payload['document_id1'] = null;
        payload['document_id2'] = null;
        payload['document_id3'] = null;
        payload['corspdc_type_ind'] = 3;
        payload['body_text'] = config.Value;
        payload['notes'] = null;
        payload['attachment'] = null;
        payload['subject'] = config.Description;
        payload['send_receive_ind'] = 11;
        payload['comm_type_ind'] = 3;
        payload['num_bookmarks'] = 0;
        payload['date_created'] = new Date();
        payload['date_modified'] = new Date();
        payload['user_created'] = this.userDetails.FirstName;
        payload['user_modified'] = this.userDetails.FirstName;
        payload['bookmark1_value'] = null;
        payload['bookmark2_value'] = null;
        payload['bookmark3_value'] = null;
        payload['bookmark4_value'] = null;
        payload['bookmark5_value'] = null;
        payload['bookmark6_value'] = null;
        //payload['from_person_id'] = this.dataCntrl.carrier.person_id;
        //payload['correspondence_person'] = [this.dataCntrl.carrier.person_id];
        payload['file_name'] = null;
        ////console.log('Application data : ', payload)
        // this.permitService.UpdatePermitNum(this.dataCntrl.permits.id).subscribe(data => {
        // });
        let oldAppID = 0;

        console.log('Payload', payload);
        this.crspdService.savePermitCorrespondence(payload, oldAppID, permitStatus, true).subscribe((data: any) => {
            this.pageload = false;
            //this.isLoading = false;
            ////console.log('Correspondence : ', data);
            if (data.isSaved == 'Success') {
                console.log('In here')
                console.log(permitStatus)

                if (permitStatus == 11 || permitStatus == 21) {
                    this.initiateWorkflow();
                } else {
                    this.processWorkflow();
                }

                if (this.renewFlag) {
                    //this.router.navigate(['carrier/permit/application/' + this.renewCrId]);
                } else {
                    this.router.navigate(['/permit-success/' + this.dataCntrl.carrierID]);
                }
            } else {
                               // this.toastr.error(`Submission for ${this.dataCntrl['carrier'].name}   failed.Please contact the system administrator if the problem persists.`, `ERROR : Confirmation`);
            }
        }, error => {
            this.pageload = false;
            //this.isLoading = false;
            console.error(`Error during permit confirmation. The server responded with error code "${error.status} : ${error.statusText}""`, `ERROR : Confirmation`);
            // this.toastr.error(`Submission for ${this.dataCntrl['carrier'].name}  failed.Please contact the system administrator if the problem persists.`, `Confirmation`);
        })


    }

    processWorkflow() {
        this.workflowService.getApplicationActivity(this.dataCntrl.application.id)
            .subscribe(
                async (result: any) => {
                    if(!result['status']){
                        if(result.userAssigned == this.userDetails.username){
                            this.setActivityData(result)
                        }
                    }
                },
                (error) => {
                }
            );
    }

    setActivityData(result){

        this.activityDTO.Activityid = result.id;
        this.activityDTO.Rolefromid = result.roleAssignedId;
        this.activityDTO.Userfrom = result.userAssigned;
        this.activityDTO.Actionid = 2;
        this.activityDTO.Actionuser = this.userDetails.username;
        this.activityDTO.Comment = "";
        this.activityDTO.Isfinalapproval = false;
        this.activityDTO.RequiresMoreInfo = false;

        this.workflowService.processActivity(this.activityDTO, 'permit')
            .subscribe(
                (resp) => {},
                (error) => {
                    console.log(error);
                    this.isLoading = false;
                });
    }
}
